export const isIosDevice = () => !!window?.navigator?.platform && /iP(ad|hone|od)/.test(window.navigator.platform)
